import { segmentScope, segmentLabel } from '../account-groups/scopes'

// How a report describes the column it was split on. Segments carry the municipality's own name
// for them, so a customer who calls seg_eight "Site / Department" reads that here too.
export const splitColumnDescription = (report, settings) => {
  if (report?.split_dimension === 'account_group') return 'account groups'

  const entry = segmentScope(report?.split_segment)
  const label = entry ? segmentLabel(entry, settings) : report?.split_segment
  return `the ${label} account segment`
}
